module.exports = __webpack_public_path__ + "img/170620.da8b6d09.png";